import React from "react";
import Icon from "../AppIcon";

/**
 * Standardized filter panel component.
 * Provides a consistent look and feel for all filter sections across the app.
 */
const FilterPanel = ({
  title = "Filters",
  children,
  onReset,
  onApply,
  hasActiveFilters = false,
  activeFilterCount = 0,
  collapsed = false,
  onToggleCollapse,
  className = "",
}) => {
  return (
  <div className={`bg-card rounded-xl border border-border ${className}`}>
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-border">
        <div className="flex items-center gap-3">
   <div className="flex items-center gap-2">
     <Icon name="Filter" size={18} className="text-muted-foreground" />
            <h3 className="font-semibold">{title}</h3>
 </div>

   {hasActiveFilters && (
      <span className="badge badge-primary badge-sm">
        {activeFilterCount} active
            </span>
          )}
        </div>

 <div className="flex items-center gap-2">
       {onReset && hasActiveFilters && (
 <button
      onClick={onReset}
        className="text-sm text-muted-foreground hover:text-foreground transition-colors flex items-center gap-1"
          >
          <Icon name="RotateCcw" size={14} />
     Reset
            </button>
   )}

      {onToggleCollapse && (
  <button
  onClick={onToggleCollapse}
              className="btn btn-ghost btn-sm p-1"
 >
  <Icon name={collapsed ? "ChevronDown" : "ChevronUp"} size={18} />
  </button>
   )}
</div>
      </div>

      {/* Filter content */}
      {!collapsed && (
        <div className="p-4">
          {children}

    {/* Apply button */}
      {onApply && (
     <div className="mt-4 pt-4 border-t border-border flex justify-end">
        <button onClick={onApply} className="btn btn-primary">
  <Icon name="Search" size={16} />
           Apply Filters
            </button>
          </div>
          )}
 </div>
      )}
    </div>
  );
};

/**
 * Standard filter row - use inside FilterPanel for consistent spacing.
 */
export const FilterRow = ({ children, className = "" }) => (
  <div
    className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 ${className}`}
  >
    {children}
  </div>
);

/**
 * Standard filter field wrapper with label.
 */
export const FilterField = ({ label, children, className = "" }) => (
  <div className={className}>
    {label && (
      <label className="block text-sm font-medium mb-1.5">{label}</label>
    )}
    {children}
  </div>
);

/**
 * Standard search input with icon.
 */
export const SearchInput = ({
  value,
  onChange,
  placeholder = "Search...",
  className = "",
}) => (
  <div className={`relative ${className}`}>
    <Icon
      name="Search"
 size={18}
      className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none z-10"
    />
    <input
      type="text"
 placeholder={placeholder}
      value={value || ""}
   onChange={(e) => onChange(e.target.value)}
      className="input pl-10 w-full"
    />
  </div>
);

/**
 * Active filter badges display.
 */
export const ActiveFilterBadges = ({ filters = [], onRemove }) => {
  if (filters.length === 0) return null;

  return (
    <div className="mt-3 pt-3 border-t border-border">
      <div className="flex items-center gap-2 flex-wrap">
     <span className="text-xs font-medium text-muted-foreground">
        Active:
        </span>
  {filters.map((filter, index) => (
    <span
            key={index}
  className="inline-flex items-center gap-1 px-2 py-0.5 bg-primary/10 text-primary text-xs rounded-full"
      >
            {filter.label}
       {onRemove && (
           <button
    onClick={() => onRemove(filter.key)}
       className="hover:bg-primary/20 rounded-full p-0.5"
 >
     <Icon name="X" size={10} />
              </button>
            )}
       </span>
        ))}
   </div>
    </div>
  );
};

export default FilterPanel;
